<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">
          Novo Técnico
        </span>
      </h3>
    </div>
    <Form url="/tecnico/create" :tecnico="tecnico" />
  </div>
</template>

<script>
import Form from "./Form.vue";
import TecnicoData from "./TecnicoData";
import { mapGetters } from "vuex";

export default {
  name: "app-tecnico-create",
  data() {
    return {
      tecnico: new TecnicoData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
